import React, { useEffect } from "react";
import DashboardWidgetContainer from "../../../containers/DashboardWidget/DashboardWidgetContainer";
import Calendar from "../../Calendar/Calendar";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import * as calendarActions from "../../../redux/actions/calendarActions";
import { widgetKeys } from "../../../constants";
import { viewDashboardWidgets } from "../../../constants";
import { calendar as learningCenterCalendarRoute } from "../../../routes/LearningCenterRoutes";
import { calendar as adminConsoleCalendarRoute } from "../../../routes/AdminRoutes";
import CalendarTooltips from "../../../views/Calendar/CalendarTooltips";
import useModal from "../../../hooks/useModal";
import ExportCalendar from "../../Calendar/Modals/ExportCalendar";

const ExportCalendarModal = ({ onResult }) => {
  const { calendarLists, feedLink } = useSelector(state => state.calendarState);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(calendarActions.fetchCalendarFeedLink());
  }, []);

  return (
    <ExportCalendar
      open={true}
      onOpenChange={() => onResult()}
      trainingCalendarList={calendarLists.training}
      calendarFeedLink={feedLink}
    />
  );
};

const calendarRoute = {
  [viewDashboardWidgets.contentTools]: adminConsoleCalendarRoute,
  [viewDashboardWidgets.learningCenter]: learningCenterCalendarRoute
};

export default function CalendarWidget({ dashboard }) {
  const { t } = useTranslation();
  const { push } = useHistory();
  const theme = useTheme();

  const user = useSelector(state => state.userState.user);
  const calendarLists = useSelector(state => state.calendarState.calendarLists);
  const loading = useSelector(
    state => state.calendarState.loading && state.userState.loadin
  );

  const openExportCalendarModal = useModal(ExportCalendarModal);

  const dispatch = useDispatch();

  const getEvents = () => {
    const allCalendars = calendarLists.training.calendars.concat(
      calendarLists.other.calendars
    );
    let events = [];
    if (calendarLists) {
      allCalendars.map(calendar => {
        return calendar.events.map(event => {
          return events.push(event);
        });
      });
    }
    return events;
  };

  let locale = user.settings.preferred_language
    ? user.settings.preferred_language
    : "en";

  useEffect(() => {
    dispatch(calendarActions.fetchCalendarInfo());
  }, []);

  const handleMenuItemClick = menuItemValue => {
    if (menuItemValue.value === "open") {
      push(calendarRoute[dashboard]);
    }
  };

  const menuOptions = (user, t) => {
    return [{ value: "open", label: t("learningCenterCalendar.options.open") }];
  };

  const events = getEvents();

  return (
    <DashboardWidgetContainer
      dashboard={dashboard}
      widgetDataLoading={loading}
      widgetKey={widgetKeys.calendar}
      title={t("learningCenterCalendar.title")}
      headerAction={
        <span className="clickable" onClick={() => openExportCalendarModal()}>
          {t("learningCenterCalendar.subscribeAction")}
        </span>
      }
      menuProps={{
        options: menuOptions(user, t),
        onMenuItemClick: handleMenuItemClick
      }}
    >
      <CalendarTooltips delayHide={50} place="right" events={events}>
        {({ onMouseEnter }) => (
          <Calendar
            events={events}
            eventTypeColors={{
              type: "eventType1",
              color: theme.palette.primary.main
            }}
            header={{
              center: null,
              right: "prev, next"
            }}
            locale={locale}
            onMouseEnter={onMouseEnter}
          />
        )}
      </CalendarTooltips>
    </DashboardWidgetContainer>
  );
}
